import React, { useState } from 'react'
import registerStyle from './CoordinatorRegisterPage.module.css'
import MainCoordinatorHeader from '../../components/MainCoordinatorHeader/MainCoordinatorHeader'
import benefitone from '../../.././assets/images/lady-img.png';
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import RegistermobilStepOne from './RegistermobilStepOne'
import RegistermobilStepTwo from './RegistermobilStepTwo'
import RegistermobilStepThree from './RegistermobilStepThree'
import { useMediaQuery } from 'react-responsive';
import Swal from "sweetalert2";
import axios from "axios";
require('typeface-poppins')

export default function CoordinatorRegisterPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  const [imagePreview, setImagePreview] = useState(benefitone);
  const [organizationImagePreview, setOrganizationImagePreview] = useState(null);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [organizationImageFile, setOrganizationImageFile] = useState(null);

  const [formData, setFormData] = useState({
    f_name: "",
    l_name: "",
    position: "",
    email_id: "",
    phone: "",
    organization_name: "",
    st_address: "",
    city: "",
    state: "",
    password: "",
    zipcode: "",
    confirmPassword: "",
    cordinator_id: "1000",
  });
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [zipError, setZipError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    /*if (name === 'phone') {
      // Remove any non-digit characters
      const phoneValue = value.replace(/\D/g, '');
      
      // Validate phone length
      if (phoneValue.length < 10) {
        setPhoneError("Phone number must be at least 10 digits");
      } else if (phoneValue.length > 15) {
        setPhoneError("Phone number cannot exceed 15 digits");
      } else {
        setPhoneError("");
      }
      
      setFormData({ ...formData, [name]: phoneValue });
    }*/
    if (name === "phone") {
      let digits = value.replace(/\D/g, "").slice(0, 10);

      if (digits.length < 10) {
        setPhoneError("Phone number must be 10 digits");
      } else {
        setPhoneError("");
      }

      setFormData(prev => ({
        ...prev,
        phone: digits
      }));
      return;
    }
    else if (name === 'email_id') {
      // Count @ symbols in email
      const atSymbolCount = (value.match(/@/g) || []).length;

      if (atSymbolCount > 1) {
        setEmailError("Email can only contain one @ symbol");
      } else {
        setEmailError("");
      }

      setFormData({ ...formData, [name]: value });
    } else if (name === 'zipcode') {
      // Remove any non-digit characters
      const zipValue = value.replace(/\D/g, '');

      if (zipValue.length > 9) {
        setZipError("Zip code cannot exceed 9 digits");
      } else {
        setZipError("");
      }

      setFormData({ ...formData, [name]: zipValue });
    } else if (name === 'password' || name === 'confirmPassword') {
      const updatedFormData = { ...formData, [name]: value };
      setFormData(updatedFormData);

      // Check password match if both fields have values
      if (updatedFormData.password && updatedFormData.confirmPassword) {
        if (updatedFormData.password !== updatedFormData.confirmPassword) {
          setPasswordError("Passwords do not match");
        } else {
          setPasswordError("");
        }
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value;

    // Remove non-digits
    const digits = rawValue.replace(/\D/g, "").slice(0, 10);

    // Validation
    if (digits.length < 10) {
      setPhoneError("Phone number must be 10 digits");
    } else {
      setPhoneError("");
    }

    // Save ONLY digits
    setFormData(prev => ({
      ...prev,
      phone: digits
    }));
  };


  // Add handler for profile image selection
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Add handler for organization image selection
  const handleOrganizationImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setOrganizationImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setOrganizationImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Modify handleSubmit to include image files
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords match before submitting
    if (formData.password !== formData.confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    // Allowed image types
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    // Validate profile image if exists
    if (profileImageFile) {
      if (!allowedTypes.includes(profileImageFile.type)) {
        Swal.fire({
          title: "Invalid File Type!",
          text: "Profile image must be a JPG or PNG file.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
      if (profileImageFile.size > maxFileSize) {
        Swal.fire({
          title: "File Too Large!",
          text: "Profile image must not exceed 5 MB.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    // Validate organization image if exists
    if (organizationImageFile) {
      if (!allowedTypes.includes(organizationImageFile.type)) {
        Swal.fire({
          title: "Invalid File Type!",
          text: "Organization image must be a JPG or PNG file.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
      if (organizationImageFile.size > maxFileSize) {
        Swal.fire({
          title: "File Too Large!",
          text: "Organization image must not exceed 5 MB.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    // Create FormData object
    const formDataToSend = new FormData();

    // Append all form data
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, formData[key]);
    });

    // Append images if they exist
    if (profileImageFile) {
      formDataToSend.append('profile_image', profileImageFile);
    }
    if (organizationImageFile) {
      formDataToSend.append('organization_image', organizationImageFile);
    }

    // Send the form data to the API
    fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/cordinator_profile_update.php`, {
      method: 'POST',
      body: formDataToSend,
    })
      /*.then(response => response.json())
      .then(data => {
        console.log(data);
        
        Swal.fire({
          title: "Thankyou for your submission",
          text: "Thank you for submitting your form.We will be sending you the terms and conditions in your email.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
      }).then((data) => {
         // navigate('/general-login');
         });
      })
      .catch(error => {
        console.error('Error:', error);
        Swal.fire({
          title: "Error!",
          text: "Failed to register. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        });
      });*/
      .then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
          // API returned error
          throw new Error(data.message || "Something went wrong");
        }

        return data;
      })
      .then((data) => {
        Swal.fire({
          title: "Thank you for your submission",
          text: "Thank you for submitting your form.We will be sending you the terms and conditions in your email.",
          icon: "success",
          timer: 2500,
          showConfirmButton: false,
        }).then((data) => {
          navigate('/general-login');
        });

        // Optional redirect
        // navigate('/general-login');
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  // Define state for the current step
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Define total steps in the process
  const totalSteps = 3;

  // Handle the next step
  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle the form submission
  const steppersubmit = () => {
    // Logic for form submission can go here
    setIsSubmitted(true);
    // console.log('Form submitted');
  };

  const formatPhone = (value) => {
    if (!value) return "";

    if (value.length <= 3) return value;
    if (value.length <= 6)
      return `${value.slice(0, 3)}-${value.slice(3)}`;

    return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
  };

  return (
    <>
      <MainCoordinatorHeader />
      {isMobile ? (
        <div className={registerStyle.coordimobilRegiscation}>
          <div className='container'>
            <div className='row'>
              <div className='col-xl-12'>
                <div className={registerStyle.coordistepperWrapper}>
                  <div className={registerStyle.coordistepperContent}>
                    {currentStep === 1 && <RegistermobilStepOne />}
                    {currentStep === 2 && <RegistermobilStepTwo />}
                    {currentStep === 3 && <RegistermobilStepThree />}
                  </div>
                  <div className={`${registerStyle.coordistepperFooter} mb-5`}>
                    {/* <button onClick={prevStep} disabled={currentStep === 1}> Back </button> */}
                    {currentStep === totalSteps ? (
                      <button className={`${registerStyle.coordinatorsubmitStepper} btn btn-warning w-100`} onClick={steppersubmit} disabled={isSubmitted}>
                        {isSubmitted ? 'Submitted' : 'Submit'}
                      </button>
                    ) : (
                      <button className={`${registerStyle.coordinatornextStepper} btn btn-warning w-100`} onClick={nextStep} disabled={currentStep === totalSteps}>
                        Next
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={registerStyle.coordinatoregisterpage}>
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-start">
              <div className="col-xl-8 col-xxl-8">
                <h3 className={registerStyle.coordinatorTitle}> Welcome Coordinator </h3>
                <form onSubmit={handleSubmit}>
                  <div className={registerStyle.coordinatorcationContent}>
                    <div className="row mb-3">
                      <div className="col-xl-9 col-xxl-9">
                        <h6> Coordinator Information </h6>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>First Name</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="f_name" value={formData.f_name} onChange={handleChange} required />
                          </div>
                          <div className="col-md-6">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Last Name</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="l_name" value={formData.l_name} onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Position</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="position" value={formData.position} onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Email Address</label>
                            <input type="email" className={`${registerStyle.coordinatorregistInput} form-control ${emailError ? 'is-invalid' : ''}`}
                              name="email_id" value={formData.email_id} onChange={handleChange} required />
                            {emailError && (
                              <div className="invalid-feedback">{emailError}</div>
                            )}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Phone:</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control ${phoneError ? 'is-invalid' : ''}`}
                              name="phone" value={formatPhone(formData.phone)} onChange={handlePhoneChange} maxLength="12" inputMode="numeric" autoComplete="tel" required />

                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3">
                        <div className={registerStyle.coordinatorimageCircle}>
                          <div className={registerStyle.coordinatorcircleEdit}>
                            <input type='file' id="coordinatorImageUpload" className={registerStyle.coordinatorCircleinput} name="imageUpload"
                              accept=".png, .jpg, .jpeg" onChange={handleProfileImageChange} />
                            <label htmlFor="coordinatorImageUpload"></label>
                          </div>
                          <div className={registerStyle.coordinatorCirclepreview}>
                            <div id="imagePreview">
                              <img src={imagePreview} alt="Profile Preview" className='img-fluid w-100 h-100 rounded-circle' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-xl-9 col-xxl-9">
                        <h6 className='pb-4'> School/Organization Information </h6>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>School /Organization Name</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="organization_name" value={formData.organization_name} onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Street Address</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="st_address" value={formData.st_address} onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>City</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control`} name="city" value={formData.city} onChange={handleChange} required />
                          </div>
                          <div className="col-md-4">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>State</label>
                            <select className={`${registerStyle.coordinatorregistSelect} form-select`} name="state" value={formData.state} onChange={handleChange}>
                              <option> -Select- </option>
                              <option value="Alabama-AL"> Alabama </option>
                              <option value="Arizona-AZ"> Arizona </option>
                              <option value="Arkansas-AR"> Arkansas </option>
                              <option value="California-CA"> California </option>
                              <option value="Colorado-CO"> Colorado </option>
                              <option value="Connecticut-CT"> Connecticut </option>
                              <option value="Delaware-DE"> Delaware </option>
                              <option value="Florida-FL"> Florida </option>
                              <option value="Georgia-GA"> Georgia </option>
                              <option value="Idaho-ID"> Idaho </option>
                              <option value="Illinois-IL"> Illinois </option>
                              <option value="Indiana-IN"> Indiana </option>
                              <option value="Iowa-IA"> Iowa </option>
                              <option value="Kansas-KS"> Kansas </option>
                              <option value="Kentucky-KY"> Kentucky </option>
                              <option value="Louisiana-LA"> Louisiana </option>
                              <option value="Maine-ME"> Maine </option>
                              <option value="Maryland-MD"> Maryland </option>
                              <option value="Massachusetts-MA"> Massachusetts </option>
                              <option value="Michigan-MI"> Michigan </option>
                              <option value="Minnesota-MN"> Minnesota </option>
                              <option value="Mississippi-MS"> Mississippi </option>
                              <option value="Missouri-MO"> Missouri </option>
                              <option value="Montana-MT"> Montana </option>
                              <option value="Nebraska-NE"> Nebraska </option>
                              <option value="Nevada-NV"> Nevada </option>
                              <option value="New Hampshire-NH"> New Hampshire </option>
                              <option value="New Jersey-NJ"> New Jersey </option>
                              <option value="New Mexico-NM"> New Mexico </option>
                              <option value="New York-NY"> New York </option>
                              <option value="North Carolina-NC"> North Carolina </option>
                              <option value="North Dakota-ND"> North Dakota </option>
                              <option value="Ohio-OH"> Ohio </option>
                              <option value="Oklahoma-OK"> Oklahoma </option>
                              <option value="Oregon-OR"> Oregon </option>
                              <option value="Pennsylvania-PA"> Pennsylvania </option>
                              <option value="Rhode Island-RI"> Rhode Island </option>
                              <option value="South Carolina-SC"> South Carolina </option>
                              <option value="South Dakota-SD"> South Dakota </option>
                              <option value="Tennessee-TN"> Tennessee </option>
                              <option value="Texas-TX"> Texas </option>
                              <option value="Utah-UT"> Utah </option>
                              <option value="Vermont-VT"> Vermont </option>
                              <option value="Virginia-VA"> Virginia </option>
                              <option value="Washington-WA"> Washington </option>
                              <option value="West Virginia-WV"> West Virginia </option>
                              <option value="Wisconsin-WI"> Wisconsin </option>
                              <option value="Wyoming-WY"> Wyoming </option>
                              <option value="District of Columbia-DC"> District of Columbia </option>
                            </select>
                          </div>
                          <div className="col-md-4">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}>Zip</label>
                            <input type="text" className={`${registerStyle.coordinatorregistInput} form-control ${zipError ? 'is-invalid' : ''}`}
                              name="zipcode" value={formData.zipcode} onChange={handleChange} maxLength="9" required />
                            {zipError && (
                              <div className="invalid-feedback">{zipError}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3">
                        <div className={registerStyle.coordinatorimageCircle}>
                          <div className={registerStyle.coordinatorcircleEdit}>
                            <input type='file' id="coordinatorImageUpload1" className={registerStyle.coordinatorCircleinput}
                              accept=".png, .jpg, .jpeg" onChange={handleOrganizationImageChange} />
                            <label htmlFor="coordinatorImageUpload1"></label>
                          </div>
                          <div className={registerStyle.coordinatorCirclepreview}>
                            <div id="imagePreview1">
                              {organizationImagePreview ? (
                                <img src={organizationImagePreview} alt="Organization Preview" className='img-fluid w-100 h-100 rounded-circle' />
                              ) : (
                                <div className='d-flex align-items-center justify-content-center h-100'>
                                  <span className='text-white text-center'>No image selected</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-9 col-xxl-9">
                        <h6 className='pb-4'> Password </h6>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}> Choose your password </label>
                            <div className={registerStyle.coordinatorpasswordWrapper}>
                              <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${registerStyle.coordinatorregistInput} form-control ${passwordError ? 'is-invalid' : ''}`}
                                name="password" value={formData.password} onChange={handleChange} required />
                              <div className={registerStyle.coordinatorTogglebutton} onClick={togglePasswordVisibility}>
                                {isPasswordVisible ? <FaEyeSlash className={registerStyle.coordiIconeye} /> : <FaEye className={registerStyle.coordiIconeye} />}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${registerStyle.coordinatorregistLabel} form-label`}> Confirm your password </label>
                            <div className={registerStyle.coordinatorpasswordWrapper}>
                              <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${registerStyle.coordinatorregistInput} form-control ${passwordError ? 'is-invalid' : ''}`}
                                value={formData.confirmPassword} onChange={handleChange} name="confirmPassword" required />
                              <div className={registerStyle.coordinatorTogglebutton} onClick={toggleCPasswordVisibility}>
                                {isCPasswordVisible ? <FaEyeSlash className={registerStyle.coordiIconeye} /> : <FaEye className={registerStyle.coordiIconeye} />}
                              </div>
                            </div>
                            {passwordError && (<div className="invalid-feedback d-block">{passwordError}</div>)}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3"> </div>
                    </div>
                    <div className="row">
                      <div className="text-center mb-3 mt-4">
                        <button className={`${registerStyle.coordinatorregistBtn} btn btn-warning `}>SUBMIT</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>)}
    </>
  )
}